import { render } from "./z-button.vue?vue&type=template&id=52e12f46"
import script from "./z-button.vue?vue&type=script&lang=js"
export * from "./z-button.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__